import {
  useQuery,
  useMutation,
  queryCache,
  BaseQueryOptions,
} from "react-query";
import axios from "axios";

export default <RESULT, BODY = any>({
  tag,
  url,
  opts,
}: {
  tag: string;
  url: string | { get: string; mutate: string };
  opts?: BaseQueryOptions;
}) => {
  return {
    useAll: () =>
      useQuery(
        tag,
        async () => {
          const { data } = await axios.get<{ data: RESULT[] }>(
            typeof url === "string" ? url : url.get
          );
          fetch("/api/orders/waited/admin")
            .then((r) => r.json())
            .then((data) => {
              console.log("asdasdasdasdasdasd");
              console.log(data.data);
            });
          console.log(tag + "tag");
          console.log(data.data);

          return data.data;
        },
        opts
      ),
    useOne: (id?: number) =>
      useQuery(
        tag + id,
        async () => {
          const { data } = await axios.get<{ data: RESULT }>(
            `${typeof url === "string" ? url : url.get}/${id}`
          );
          return data.data;
        },
        opts
      ),
    useSome: (ids: number[]) =>
      useQuery(
        tag + JSON.stringify(ids),
        async () => {
          const res = await axios.all<{ data: { data: RESULT } }>(
            ids.map((id) =>
              axios.get(`${typeof url === "string" ? url : url.get}/${id}`)
            )
          );
          return res.map((r) => r.data.data);
        },
        opts
      ),
    useMutate: <MUTATE_RESULT = RESULT>() => {
      const [mutate, result] = useMutation<
        MUTATE_RESULT,
        {
          body?: BODY;
          type: "post" | "put" | "delete";
          id?: number | string;
          onSuccess?: (res: MUTATE_RESULT) => void;
          onError?: (error: any) => void;
        }
      >(
        async (args) => {
          const mutateUrl = `${typeof url === "string" ? url : url.mutate}${
            args.id ? `/${args.id}` : ""
          }`;
          let data;
          if (args.type === "delete") {
            try {
              const res = await axios.delete<{ data: MUTATE_RESULT }>(
                mutateUrl
              );
              data = res.data;
            } catch (error) {
              args.onError && args.onError(error);
              throw error;
            }
          } else {
            try {
              const res = await axios[args.type]<{ data: MUTATE_RESULT }>(
                mutateUrl,
                args.body
              );
              data = res.data;
            } catch (error) {
              args.onError && args.onError(error);
              throw error;
            }
          }
          args.onSuccess && args.onSuccess(data.data);
          return data.data;
        },
        {
          onSuccess: (data, { id }) => {
            queryCache.invalidateQueries(tag, { refetchInactive: true });
            id &&
              queryCache.invalidateQueries(tag + id, { refetchInactive: true });
          },
        }
      );
      return {
        mutate,
        result,
      };
    },
  };
};
